import { useNotificationsStore } from '../../stores/notifications'

export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.client && to.path !== from.path) {
    try {
      const notificationsStore = useNotificationsStore()
      notificationsStore.clearNonPersistentNotifications()
    } catch (error) {
      // Silently fail if store is not available
      console.warn('Notifications store not available:', error)
    }
  }
})
